import './instrument';

import { Buffer as BufferPolyfill } from 'buffer';

const globalScope = globalThis as typeof globalThis & { Buffer?: typeof BufferPolyfill };
globalScope.Buffer = globalScope.Buffer ?? BufferPolyfill;

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { PaddiqProvider } from '@kangaroo/ui';

import { App } from './App';
import { AppErrorBoundary, ClientErrorListeners } from './components/ErrorBoundary';
import { queryClient } from './lib/queryClient';
import { installSentryUserSync } from './lib/sentryUser';

installSentryUserSync();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <PaddiqProvider>
        <AppErrorBoundary>
          <ClientErrorListeners />
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AppErrorBoundary>
      </PaddiqProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
